import React, { FC, useState } from "react";
import { Box, Button, CloseButton, Flex, Tooltip, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChakraFAIcon } from "../ui/Icon";
import BlankFavicon from "@/assets/studentTile/favicons/blank-favicon.svg?url";
import { convertWebsiteToSignature } from "@/utils/convertWebsiteToSignature";

interface Props {
	isActiveTab?: boolean;
	forceCloseTab: (tabId: string, isActiveTab?: boolean) => void;
	classIsActive: boolean;
	handleOpenRuleModal: (url: string, signature: string) => void;
	title: string;
	faviconUrl: string;
	chromeTabId?: string;
	canCloseTab: boolean;
	canApplyRule: boolean;
	websiteUrl: string;
	itemKey: string;
	isMonitorMode: boolean;
	isStudentClaimed: boolean;
	policiesEnabled: boolean;
}

export const ListItem: FC<Props> = ({ isActiveTab = false, ...props }) => {
	const { t } = useTranslation();
	const [isClosed, changeClosed] = useState(false);

	const handleClose = () => {
		if (props.chromeTabId) {
			props.forceCloseTab(props.chromeTabId, isActiveTab);
		}
		changeClosed(true);
	};

	const disableClose = () => {
		return !props.chromeTabId || isClosed || !props.classIsActive;
	};

	const isInternalBrowserTab = (url: string) => {
		return url.startsWith("chrome") || url.startsWith("edge");
	};

	// convert the website url to a signature
	const signature = convertWebsiteToSignature(props.websiteUrl) || "";

	// if there is a signature, use the signature and set the url to undefined
	const url = signature ? "" : props.websiteUrl;

	return (
		<Flex alignItems={"center"} key={props.itemKey} backgroundColor="#F4F5F7" mb={2} px={2} borderRadius="md">
			<Image
				h={"20px"}
				w={"20px"}
				mr={2}
				src={isInternalBrowserTab(props.websiteUrl) || !props.faviconUrl ? BlankFavicon : props.faviconUrl}
			/>
			<Box flex={30} overflowX={"hidden"} textOverflow={"ellipsis"} whiteSpace={"nowrap"}>
				{props.title}
			</Box>
			{!props.isMonitorMode && props.isStudentClaimed && props.canApplyRule && props.policiesEnabled && !!props.websiteUrl && (
				<Button onClick={() => props.handleOpenRuleModal(url, signature)} size={"sm"} py={5} variant={"ghost"} mx={2}>
					<ChakraFAIcon icon="fa-pencil" mr="2" />
					{t("websitesListItem.rule")}
				</Button>
			)}
			{props.canCloseTab && props.isStudentClaimed && (
				<Box flex={1}>
					<Tooltip label={t("websitesListItem.closeTab")} aria-label={t("websitesListItem.closeTab")} hasArrow placement={"top"}>
						<CloseButton disabled={disableClose()} onClick={handleClose} />
					</Tooltip>
				</Box>
			)}
		</Flex>
	);
};
